import React, { useState } from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import ContentHtml from './../../../../components/content/ContentHtml/ContentHtml.component'
import env from './../../../../environments/environment'

import './RoyalRingShowcase.component.scss'

const RingOptionCard = ({ ring }) => {
  const [imageError, setImageError] = useState(false)

  return (
    <MDBCol md='6' lg='3' className='ring-option-col'>
      <div className='ring-option-card'>
        <div className='ring-image-wrapper'>
          {!imageError ? (
            <img
              src={ring.image}
              alt={`${ring.title} - Royal Ring`}
              className='ring-image'
              onError={() => setImageError(true)}
            />
          ) : (
            <div className='ring-image-placeholder'>
              <div className='placeholder-content'>
                <i className='fas fa-gem fa-3x'></i>
                <span>Ring Image</span>
              </div>
            </div>
          )}
        </div>
        <div className='ring-info'>
          <h3 className='ring-option-name'>{ring.name}</h3>
          <p className='ring-title'>{ring.title}</p>
          <p className='ring-description'>{ring.description}</p>
        </div>
      </div>
    </MDBCol>
  )
}

const RoyalRingShowcase = () => {
  const getRingImageUrl = filename => {
    const storageBucket = env.integrations.firebase.config.storageBucket
    const encodedPath = encodeURIComponent(`static/rings/${filename}`)
    return `https://firebasestorage.googleapis.com/v0/b/${storageBucket}/o/${encodedPath}?alt=media`
  }

  const ringOptions = [
    {
      id: 1,
      // name: 'Option 1',
      title: '14K Gold',
      image: getRingImageUrl('ring-option-1-14k-gold.png'),
      // description: 'Classic yellow gold elegance',
    },
    {
      id: 2,
      // name: 'Option 2',
      title: '14K Gold/White Gold Accents',
      image: getRingImageUrl('ring-option-2-gold-white-accents.png'),
      // description: 'Yellow gold with white gold accents',
    },
    {
      id: 3,
      // name: 'Option 3',
      title: '14K White Gold',
      image: getRingImageUrl('ring-option-3-14k-white-gold.png'),
      // description: 'Timeless white gold sophistication',
    },
    {
      id: 4,
      // name: 'Option 4',
      title: '14K White Gold/Yellow Gold Accents',
      image: getRingImageUrl('ring-option-4-white-gold-gold-accents.png'),
      // description: 'White gold with yellow gold accents',
    },
  ]

  return (
    <div className='royal-ring-showcase'>
      <MDBContainer>
        <div className='showcase-header'>
          <h2 className='showcase-title'>Race to the Royal Ring</h2>
          <p className='showcase-subtitle'>USABG's Coveted, Lifetime Achievement Award</p>
          <p className='showcase-description'>A giant, gold and diamond-encrusted symbol of your success!</p>
        </div>

        <div className='rings-grid'>
          <MDBRow className='justify-content-center'>
            {ringOptions.map(ring => (
              <RingOptionCard key={ring.id} ring={ring} />
            ))}
          </MDBRow>
        </div>

        <div className='showcase-footer'>
          <div className='content-wrapper royal-ring-content-wrapper text-center'>
            <ContentHtml contentSlug='royal-ring-program-details' />
          </div>
          <div className='usabg-logo'>
            <div className='logo-line'></div>
            <h3 className='logo-text'>
              USA Benefits Group<sup>®</sup>
            </h3>
            <div className='logo-line'></div>
          </div>
          <p className='logo-tagline'>Health • Life • Senior Insurance</p>
        </div>
      </MDBContainer>
    </div>
  )
}

export default RoyalRingShowcase
